import React from 'react';
const OptionsItemButton = function ({ children, onClick }) { return /*#__PURE__*/ React.createElement("a", { href: "#", className: "options__item__button button button--default button--small", onClick: onClick }, children); };
export default OptionsItemButton;
